import React, { useEffect, useState } from "react";
import propTypes from "prop-types";
import Sidebar from "../Sidebar";
import { DatePicker, Grid } from "antd";
import dayjs from "dayjs";
import { Link } from "react-router-dom";
import {
  searchnormal,
} from "../imagepath";

const { useBreakpoint } = Grid;

// --- Main Component ---
const AnalyticsData = () => {

  const screens = useBreakpoint();
  const [loading, setLoading] = useState(false);
  const [startDate, setStartDate] = useState(dayjs());
  const [endDate, setEndDate] = useState(dayjs());

  const customFormat = (value) => {
    return value.format("DD-MM-YYYY");
  };

  // Responsive font sizes
  const getFontSize = (base, sm, xs) => {
    if (screens.xs) return xs;
    if (screens.sm) return sm;
    return base;
  };

  useEffect(() => {
    const sidebar = document.getElementById("sidebar");

    if (sidebar)
    {
      sidebar.classList.add("sidebar-doctor");
      sidebar.id = "menu-item1"; // Change ID if needed
    }

    document.body.classList.remove("expand-menu");
    document.body.classList.add("mini-sidebar");
  }, []);

  return (
    <div>
      <Sidebar activeClassName="consultantion-fee" />

      <div className="page-wrapper-doctor">
        <div className="content">
          <div className="page-header">
            <h3 className="page-title font-weight-bold">Analytics</h3>
          </div>

          <div className="row mt-4">
            <div className="col-xl-2">
              <div className="widget settings-menu setting-list-menu">
                <ul className='mb-0'>
                  <li className="nav-item">
                    <span>Patients</span>
                  </li>
                  <li className="nav-item">
                    <span>Revenue</span>
                  </li>
                  <li className="nav-item">
                    <span>Symptoms</span>
                  </li>
                  <li className="nav-item">
                    <span>Diagnosis</span>
                  </li>
                  <li className="nav-item">
                    <span>Medicines</span>
                  </li>
                  <li className="nav-item">
                    <span>Investigations</span>
                  </li>
                  <li className="nav-item">
                    <span>Vaccinations</span>
                  </li>
                </ul>
              </div>
            </div>

            <div className="col-xl-10">
              <div className="row align-items-center mb-4">
                <div className="col-3">
                  <div className="d-flex">
                    <DatePicker
                      size={screens.xs ? "small" : "middle"}
                      value={startDate}
                      onChange={(date) => setStartDate(date)}
                      format={ customFormat}
                      allowClear={true}
                      className="me-3"
                    />

                    <DatePicker
                      size={screens.xs ? "small" : "middle"}
                      value={endDate}
                      onChange={(date) => setEndDate(date)}
                      format={ customFormat}
                      allowClear={true}
                    />
                  </div>
                </div>

                <div className="col-9">
                  <ul className="d-flex ps-0 mb-0" style={{listStyle: "none", justifyContent: "space-between"}}>
                    <li>
                      <Link to="#">Today</Link>
                    </li>
                    <li>
                      <Link to="#">1W</Link>
                    </li>
                    <li>
                      <Link to="#">2W</Link>
                    </li>
                    <li>
                      <Link to="#">1M</Link>
                    </li>
                    <li>
                      <Link to="#">3M</Link>
                    </li>
                    <li>
                      <Link to="#">6M</Link>
                    </li>
                    <li>
                      <Link to="#">1Y</Link>
                    </li>
                    <li>
                      <Link to="#">ALL</Link>
                    </li>
                  </ul>
                </div>
              </div>

              {/* Visits and patients start */}
              <div className="card">
                <div className="card-header border-bottom border-dark px-3">
                  <h5 className="card-title">Visits and patients</h5>
                </div>

                <div className="card-body">
                  <div className="row align-items-center pb-3">

                    <div className="col-md-3">
                      <div className="d-grid text-center p-2">
                        <span>0</span>
                        <span>Total Visits</span>
                      </div>
                    </div>

                    <div className="col-md-3">
                      <div className="d-grid text-center p-2">
                        <span>0</span>
                        <span>Total Patients</span>
                      </div>
                    </div>

                    <div className="col-md-3">
                      <div className="d-grid text-center p-2">
                        <span>0</span>
                        <span>Old Patients</span>
                        <Link to="#">Show Data</Link>
                      </div>
                    </div>

                    <div className="col-md-3">
                      <div className="d-grid text-center p-2">
                        <span>0</span>
                        <span>New Patients</span>
                        <Link to="#">Show Data</Link>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
              {/* Visits and patients end */}

              {/* Revenue start */}
              <div className="card">
                <div className="card-header border-bottom border-dark px-3">
                  <h5 className="card-title">Revenue - by type of billing</h5>
                </div>

                <div className="card-body">
                  <div className="row align-items-center pb-3">

                    <div className="col-md-3">
                      <div className="d-grid text-center p-2">
                        <span>₹ 0</span>
                        <span>Total</span>
                      </div>
                    </div>

                  </div>
                </div>

                <div className="card-header border-top border-bottom border-dark px-3">
                  <h5 className="card-title">Revenue - by mode of billing</h5>
                </div>

                <div className="card-body">
                  <div className="row align-items-center pb-3">

                    <div className="col-md-3">
                      <div className="d-grid text-center p-2">
                        <span>₹ 0</span>
                        <span>Total</span>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
              {/* Revenue end */}

              {/* Top Symptoms start */}
              <div className="card">
                <div className="card-header border-bottom border-dark px-3">
                  <div className="doctor-table-blk"  style={{justifyContent: "space-between"}}>
                    <h5 className="card-title">Top Symptoms</h5>

                    <div className="doctor-search-blk">
                      <div className="top-nav-search table-search-blk">
                        <form>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Search here"
                          />
                          <Link className="btn">
                            <img src={searchnormal} alt="#" />
                          </Link>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="card-body">
                  <div className="row align-items-center pb-3">

                    <div className="col-md-3">
                      <div className="d-grid text-center p-2">
                        <span>0</span>
                        <span>Total Visits</span>
                      </div>
                    </div>

                    <div className="col-md-3">
                      <div className="d-grid text-center p-2">
                        <span>0</span>
                        <span>Total Patients</span>
                      </div>
                    </div>

                    <div className="col-md-3">
                      <div className="d-grid text-center p-2">
                        <span>0</span>
                        <span>Old Patients</span>
                        <Link to="#">Show Data</Link>
                      </div>
                    </div>

                    <div className="col-md-3">
                      <div className="d-grid text-center p-2">
                        <span>0</span>
                        <span>New Patients</span>
                        <Link to="#">Show Data</Link>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
              {/* Top Symptoms end */}

            </div>
        </div>
        </div>
      </div>
    </div>
  );
};

export default AnalyticsData;